<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  data () {
    return {
      placaPosicaoNValido: [],
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      alerta: state => state.moduleAlerta.alerta,
      placa: state => state.moduleAlerta.alerta.placa,
    }),
  },
  watch: {
    placa () {
      var placaAux = this.placa.toUpperCase()
      this.placaPosicaoNValido = []
      var e = [...placaAux]
      var aux = ''
      aux = this.preechendoPlaca(e[0])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(1)
      aux = this.preechendoPlaca(e[1])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(2)
      aux = this.preechendoPlaca(e[2])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(3)
      aux = this.preechendoPlaca(e[3])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(4)
      aux = this.preechendoPlaca(e[4])
      !aux.match(/^[A-Z|\d]$/) && this.placaPosicaoNValido.push(5)
      aux = this.preechendoPlaca(e[5])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(6)
      aux = this.preechendoPlaca(e[6])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(7)
      this.alerta.placaValido = 0 == this.placaPosicaoNValido.length
      this.alerta.placaCompleta = 7 == this.placa.length

      if(this.alerta.placaValido && this.alerta.placaCompleta){
        this.buscarPlaca(this.placa)
      }
    },    
  },
  methods: {
    formatandoData(data) {
      var d = new Date(data),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [day, month, year].join('/');
    },
    formatarPlaca (e) {
        return e.toUpperCase()
    },
    preechendoPlaca (e) {
      if (e != undefined)
        return e
      else 
        return ''
    },
    buscarPlaca(){
      this.$store.dispatch("BUSCARPLACAALERTA", {
        codUsuario: this.usuario.codUsuario,
        cidade: this.user.cidade,
        placa: this.alerta.placa
      }).then((result) => {
          if (result.length > 0) {
            this.btnBuscarAlertaVsible = false
            this.alerta.codOcorrencia = result[0].CodOcorrencia
            this.alerta.cor = result[0].Cor
            this.alerta.modelo = result[0].Modelo
            this.alerta.tipoAlerta = result[0].TipoAlerta
            this.alerta.recomendacao = result[0].Recomendacao
            this.alerta.detalhe = result[0].Detalhe
            this.alerta.dataInicial = new Date(result[0].DatInicio).toISOString().split('T')[0]
            this.alerta.dataFinal = new Date(result[0].DatFinal).toISOString().split('T')[0]
            this.alerta.idTelegram = result[0].Telegram.split(',')
            this.$swal.fire({
              title: "Buscando Placa",
              text: "Sucesso",
              icon: "info"
            })
            this.alerta.estado = "alterar_ativo"
          }
          else {
            this.$swal.fire({
              title: "Buscado Alerta",
              text: 'Não possui cadastro de alerta',
              icon: "warning"
            })
            if (this.alerta.estado == 'novo')
              this.alerta.estado = 'novo_ativo'
            else
              this.alerta.estado = ''
          }
        }
      )
    },
  }
}
</script>
<template>
  <div>
    <b-form-text>Placa:</b-form-text>
    <b-form-input class="shadow rounded" v-model="alerta.placa" :state="(alerta.placaValido && alerta.placaCompleta) || ativar" :formatter="formatarPlaca" style="letter-spacing: 5px" maxLength=7 
                  :readonly="ativar"/>
    <b-form-invalid-feedback v-if="!alerta.placaCompleta" v-show="!ativar"> Placa Incompleta </b-form-invalid-feedback>
    <b-form-invalid-feedback v-else> Placa Invalida na posicao: {{placaPosicaoNValido.join()}} </b-form-invalid-feedback>
  </div>
</template>

<style>

</style>